import React from 'react';

const Footer = () => {
    return (
        <footer className="mt-5 mb-md-5">
            <h4 className="text-center">All Rights Reserved || Raj Dev</h4>
        </footer>
    );
};

export default Footer;